import { useContext } from 'react';
import './ListHeader.css';
import { DialogContext } from '../context/DialogContext'; // DialogContext import
import ListPageSetup from './ListPageSetup';

const ListHeader = ({
  keyword,
  setKeyword,
  handleSearch,
  handleSettingsSave,
  sort,
  desc,
  rowsPerPage,
  total,
  sortOptions,
  page,
  setPage,
  totalPages,
  buttons
}) => {
  const { openDialog, closeDialog } = useContext(DialogContext);

  // 설정 버튼 클릭 시 DialogContext를 통해 다이얼로그로 ListPageSetup을 띄움
  const handleSettingsClick = () => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 색상
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(<ListPageSetup
      onClose={closeDialog}
        onSave={handleSettingsSave}
        initialSort={sort}
        initialDesc={desc}
        initialRowsPerPage={rowsPerPage}
        total={total}
        sortOptions={sortOptions}
      />, customStyles);
  };

  return (
    <ul className="list_header">
      <li>
        <input
          type="text"
          placeholder="키워드 검색"
          className="keyword"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <button onClick={handleSearch}>
          검색
        </button>
        <button onClick={handleSettingsClick}>
          설정
        </button>
        {buttons}
      </li>
      <li>
        <input type="number" className="page" value={page} onChange={(e) => setPage(Number(e.target.value))} />
        <span> / {totalPages} 페이지</span>
        <button onClick={() => setPage(page - 1)} disabled={page === 1}>
          이전
        </button>
        <button onClick={() => setPage(page + 1)} disabled={page === totalPages}>
          다음
        </button>
      </li>
    </ul>
  );
};

export default ListHeader;